import * as React from 'react';
import Button from '../../components/Button/Button'
import Icon from 'react-fa';
const styles = require('./Help.less') as any;
//import './Help.less'
const BackToTop = () => <a href='#toc'>Back to top <Icon name='caret-square-o-up' /></a>
const ScreenShot = ({file, title, className={}, style={}}) =>
<div style={{...style}} className={styles.Screenshot}>
	<img src={require('./screenshots/'+file)} alt={title} title={title} />
</div>

const FinishLater = () => <Button className={styles.exampleButton} type='button' kind='secondary'>Finish Later</Button>
const Next = () => <Button className={styles.exampleButton} type='button'>Next <Icon name='caret-right' /></Button>
const Previous = () => <Button className={styles.exampleButton} type='button'><Icon name='caret-left' /> Previous</Button>

const SiteUrl = () => <span>https://accessplace.org</span>
export default class HelpPage extends React.Component<any,any> {
	render() {
	return (
		<div id="helpPage">
			<h1 id='toc'>Help</h1>
			<ol>
				<li><a href='#loggingIn'>Logging in</a></li>
				<li><a href='#loggingOut'>Logging out</a></li>
				<li><a href='#registration'>Creating a new Account</a></li>
				<li><a href='#registrationWizard'>Health Profile upon Registering</a></li>
				<li><a href='#healthProfile'>Filling out the Health Profile</a></li>
				<li><a href='#searching'>Searching</a></li>
				<li><a href='#popups'>Pop-ups</a></li>
				<li><a href='#reviewing'>Reviewing</a>
					<ol>
						<li><a href='#writingReview'>Writing Reviews</a></li>
						<li><a href='#editingReviews'>Editing Reviews</a></li>
					</ol>
				</li>
				<li><a href='#troubleshooting'>Troubleshooting GPS</a>
					<ol>
						<li><a href='#locationDenied'>Location denied</a>
							<ol>
								<li><a href='#deniedChrome'>Chrome</a></li>
								<li><a href='#deniedSafari'>Safari</a></li>
							</ol>
						</li>
						<li><a href='#locationUnavailable'>Location unavailable</a>
							<ol>
								<li><a href='#unavailableChrome'>Chrome</a></li>
								<li><a href='#unavailableSafari'>Safari</a></li>
								<li><a href='#unavailableWindows'>Windows</a></li>
								<li><a href='#unavailableiOS'>iOS</a></li>
								<li><a href='#unavailableAndroid'>Android</a></li>
							</ol>
						</li>
					</ol>
				</li>
			</ol>

			<section>
				<h2 id='loggingIn'>Logging in</h2>
				<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in non-mobile view' file='login-top.PNG' />
				<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in mobile view' file='login-bottom.PNG' />
				<p>You can log in by going to the blue navigation bar located on the right side, top right, or bottom of your screen, depending on the device and page you are viewing. Click on the [Login] button in the navigation bar, or click on the [Login] button on the welcome page for AccessPlace.</p>
				<BackToTop />
			</section>

			<section>
				<h2 id='loggingOut'>Logging out</h2>
				<ScreenShot style={{float: 'left'}} title='Screenshot of Login button when in non-mobile view' file='AccessPlace - Account.png' />
				<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in non-mobile view' file='login-top.PNG' />
				<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in mobile view' file='login-bottom.PNG' />
				<p>You can log out by going to the blue navigation bar located on the right side, top right, or bottom of your screen, depending on the device and page you are viewing. Click on Settings, and then click on the black and yellow <Button className={styles.exampleButton} type='button' kind='warn'>Logout</Button> button.</p>

				<BackToTop />
			</section>
			<hr />

			<section>
				<h2 id='registration'>Creating a new Account</h2>
				<p>Needs content</p>

				<section>
					<h2 id='registrationWizard'>Health Profile upon Registering</h2>
					<ScreenShot style={{float: 'right'}} title='Screenshot of the Profile creation wizard' file='Wizard Page.png' />
					<p>After registering, you will be taken to the Welcome page. The next few pages will ask you some basic questions about demographics, health conditions, and any assistive technology for you, your family member, friend, or client. Use the <Next />  button to navigate to the first page of the profile. Click the <FinishLater /> button if you do not wish to complete the profile right away, or want to finish it at a later date.</p>

					<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in mobile view' file='Wizard Page (1).png' />
					<p>There are seven pages of questions. Answer each question to the best of your knowledge. Use the <Previous /> and <Next /> buttons to navigate the pages. The Health information page will have various areas of impairment. Click on the blue box to the left of the text of any impairment that applies to the person the profile is describing. The impairments that you click on this page will pre-populate the next page.</p>

					<p>The next page will ask you more questions about each impairment.</p>

					<p>Once you have finished, you will be taken to the “Search” page. To go back to your Health Profile, go the navigation bar and click on “Profile”.</p>
					<BackToTop />
					<section>
						<h3 id='healthProfile'>Filling out the Health Profile</h3>
						<ol>
							<li>To create a health profile, click [Profile] on the navigation bar.</li>
							<li>Choose whom the profile is being created for under the heading “This Profile Describes”.
								<ol>
									<li>Four options are available: For Yourself, For A Relative, For A Client, or For A Friend.</li>
								</ol>
							</li>
							<li>Enter the individual’s name, birth year, sex, and zip code.</li>
							<li>
								<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in mobile view' file='Wizard Page (7).png' />
								After providing the general information about the person the profile is about, you will be asked to answer questions about their health conditions.
								<ol>
									<li>There are nine categories: Mobility, vision, hearing, cognition, communicating, upper extremity, lower extremity, sensory sensitivities, and head/neck/back.</li>
									<li>Clicking on one of these categories will bring up more detailed questions. Answer these questions to the best of your knowledge.</li>
								</ol>
							</li>
							<li>The last section of the health profile will ask you about assistive technology used by the individual.
								<ol>
									<li>Clicking on the small box to the left of the description will allow you to select it.</li>
									<li>If there is an assistive device used that is not listed, you can enter it below the heading “Other Assistive Technology”.</li>
								</ol>
							</li>
							<li>Once you have completed all sections of the Health Profile, click Save at the bottom of the page.</li>
						</ol>
					</section>
					<BackToTop />
				</section>
			</section>
			<hr />

			<section>
				<h2 id='searching'>Searching</h2>

				<ol>
					<li>
						<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in non-mobile view' file='AccessPlace - Search - Desktop.png' />
						The search page allows you to search for public places. You will be taken to the search page automatically once you have completed your profile. or you can reach it by clicking on [Search] in the navigation bar.</li>
						<li>You will see a map with a search bar along with a list of places near you on the left hand side of the screen. (screen shot).</li>
						<li>You can search in the area near you (this is the default, or normal search), or pick a different location (“Steak in Toronto”, “Pizza near Honolulu”).</li>
						<li>You can search for general types of things ("pizza", "food", "universities"), or more specific place names ("McDonald's", "Starbucks").</li>
						<li>You can select a place by clicking on the list, or by clicking on the marker(image) on the map.</li>
						<li>Once you have selected a place, you will have the option to view reviews(image), write a review(image), or if you have already written a review, edit that review (image). You can do this either by using the buttons in the list, or the popup on the map (in full computer mode).</li>
						<li>Note that you can NOT search for residences (homes, apartments, condos) or specific addresses.</li>
				</ol>
				<BackToTop />
				<section>
					<h3 id='popups'>Pop-ups</h3>
					<ol>
						<li>When searching for a place, you will see a text box pop-up on the map where the place is located.</li>
						<li>This pop-up will also contain links to “View Reviews”	and “Write a Review”, or "Edit Your Review". Clicking on any of these links will take you to the Reviews page, where you can write, edit or view reviews/ratings.</li>
						<li>To close the pop-up click the “x” on the top right of the box.</li>
					</ol>
				</section>
				<BackToTop />
			</section>
			<hr />

			<section>
				<h2 id='reviewing'>Reviewing</h2>
				<section>
					<h3 id='writingReviews'>Writing Reviews</h3>
					<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in non-mobile view' file='AccessPlace - Search - Selected - Mobile.png' />
					<ol>
						<li>Search for a place you wish to review.</li>
						<li>Click on the desired place in the dropdown menu.</li>
						<li>Click on the button that reads “Write a review” for the selected place. (Note that if you have already submitted a review, the button will read “edit your review”).</li>
						<li>There will be a list of building elements, with "Overall Accessibility" at the top.</li>
						<li>Click on the building element (or Overall Accessibility) you wish to review.<ScreenShot style={{float: 'right'}} title='Screenshot of Login button when in non-mobile view' file='AccessPlace - Place - Reviewing - Mobile.png' /></li>
						<li>A text box will appear to the right of the building element. Write your comment here.</li>
						<li>You are allowed up to 1000 characters (including spaces). There is an indicator in the bottom right corner that keeps track of this for you.</li>
						<li>Add a star rating for the building element. This is needed in order to save your comments and review.</li>
						<li>You add a rating by clicking on the stars located on the top right of the text box</li>
						<li>Click on the amount of stars you wish to give that specific building element, with one star being the worst rating (horrible accessibility!) and five starts being the best (great accessibility!).</li>
						<li>Once you have written your comments and left star ratings for all of the elements you wished to review for that place, click the blue [save all] located either next to the place name, in full computer mode, or in the bottom left corner in mobile view. (images). You can save your ratings at any time by clicking the [save all] button. If you do not click the [save all] button before leaving the review screen, your review will not be saved.</li>
						<li>Click on “close” when finished.</li>
						<li>Click the blue arrow on the top left hand side next to the name of the place to return back to the search page.</li>
					</ol>
					<BackToTop />
				</section>

				<section>
					<h3 id='editingReviews'>Editing Review</h3>
					<p>Editing reviews is similar to writing new reviews. Follow the directions given below to edit a pre-existing review.</p>
					<ol>
						<li>Search for a place you have previously written a review for.</li>
						<li>Click on the building under the dropdown menu, or the popup on the map.</li>
						<li>Click the button that reads “Edit a Review” for the selected building.</li>
						<li>You will see a list of buiding elements, with "Overall Accessibility" at the top. (image)</li>
						<li>Edit a review for a building element in the right hand column in the text box provided.</li>
						<li>A green checkmark (IMAGE) will be located to the left of all building elements you have previously reviewed.</li>
						<li>Click on a building element you wish to edit.</li>
						<li>Edit a review for a building element in the text box provided.</li>
						<li>You can edit ratings by clicking on the stars located above the text box.</li>
						<li>You can save your reviews at any time during this process by clicking the “save all” button. If you do not click the “save all” button before leaving the review menu, it will not be auto-saved.</li>
						<li>Click “close” when complete.</li>
						<li>Click the blue arrow on the top left hand side of the name of the place to return to the search page.</li>
						<li>You can also edit your review from the "View reviews" page. If you have left a review for any building element, there will be a button (image) that you can click on at the bottom of your review that will allow you to edit it. Follow the same procedure for editin as described above.</li>
					</ol>
				</section>
				<BackToTop />
			</section>
			<hr />

			<section>
				<h2 id='troubleshooting'>Troubleshooting GPS</h2>
				<section>
					<h3 id='locationDenied'>Location denied</h3>
					<section>
						<h4 id='deniedChrome'>Chrome</h4>
						<p>Go to the upper right hand corner of your screen on AccessPlace. Click on the GPS(image) location icon, then click on manage location settings. For <SiteUrl />, if the behavior says “blocked” cancel this function by clicking on the x that appears when highlighted.</p>
						<p>Refresh <SiteUrl />. When refreshed a pop-up box will appear asking to know your location for AccessPlace. Click Allow.</p>
						<BackToTop />
					</section>
					<section>
						<h4 id='deniedSafari'>Safari</h4>
						<p>Coming soon.</p>
						<BackToTop />
					</section>
				</section>
				<section>
					<h3 id='locationUnavailable'>Location unavailable</h3>
					<section>
						<h4 id='unavailableChrome'>Chrome</h4>
						<p>Coming soon.</p>
						<BackToTop />
					</section>

					<section>
						<h4 id='unavailableSafari'>Safari</h4>
						<p>Coming soon.</p>
						<BackToTop />
					</section>
					<section>
						<h4 id='unavailableWidnows'>Windows</h4>
						<p>Make sure the GPS locator is switched on by going to the Control Panel on your computer. On the Control Panel Home screen, Click on Location and Other Sensors. Make sure the sensor is Enabled.</p>
						<BackToTop />
					</section>
					<section>
						<h4 id='unavailableiOS'>Mac OS X</h4>
						<p>To make sure the GPS locator is switched On choose System Preferences from the Apple menu. Choose the Security & Privacy icon in the System Preferences window. Then, click the Privacy tab.</p>
						<p>If the padlock icon in the lower left is locked (LockIcon). Click it and enter an admin name and password to unlock it (UnlockIcon).</p>
						<p>Select Location Services. Check the "Enable Location Services" checkbox.</p>
						<p>Refresh <SiteUrl />. A pop-up will appear asking to allow this website to use your current location. Click “Allow”.</p>
						<BackToTop />
					</section>

					<section>
						<h4 id='unavailableiOS'>iOS</h4>
						<p>To make sure the GPS locator is turned On, Go to iPad settings and click on Privacy. Then click on Location Services. Make sure Location Services is turned on for the web browser you are currently using.</p>
						<p>After turning on Location Services refresh AccessPlace. A pop-up will show asking if you would like to Allow or Don’t allow AccessPlace to use your current location. Click "OK".</p>
						<BackToTop />
					</section>
					<section>
						<h4 id='unavailableAndroid'>Android</h4>
						<p>Coming soon.</p>
					</section>
					<BackToTop />
				</section>
			</section>
		</div>
	);
	}
}

/* const TOC = ({children}) => {
 *
 * 	return (<div>
 * 		<TableOfContents content={children} />
 * 		{children.map(child => L)}
 *
 * 	</div>)
 * }
 *
 * import inRange from 'lodash/inRange'
 * const H = ({level}, children) => {
 *   const Tag = `h${level}`;
 *   return inRange(level, 1, 7) ? <Tag>{children}</Tag> : <span>{children}</span>;
 * };
 * const TableOfContents = ({content, title, level=0}) => {
 * 	return (<ol>
 * 		{content.map(child => (
 * 			 <li>
 * 				 <H level={level}>{child.title}</H>
 * 				 {child.children && <TableOfContents title={child.title} content={child.children} level={level+1} />}
 * 			 </li>)
 * 		 )}
 * 	</ol>)
 * }*/



// WEBPACK FOOTER //
// ./src/app/containers/Help/Help.tsx